import React, { useContext, useState, useEffect } from 'react'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ApiService from '../../data/services/ApiService'
import SuppliersList from '../../components/Common/Lists/Suppliers'

const Index = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const [suppliers, setSuppliers] = useState([])

  const fetchSuppliers = async () => {
    try {
      setLoading(true)
      const response = await ApiService.getSuppliers()
      setSuppliers(response.data.suppliers)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    (async function fetch() {
      await fetchSuppliers()
    })()
  }, []) // eslint-disable-line

  const itemAction = (item) => {
    window.analytics.track("Go to brand page", { brand: item.nombreComercial })
    props.history.push(`/marcas/${item.supplierCode}`)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Marcas"
            breadcrumbItem={`Marcas`}
            parentLink={`/marcas`}
          />
          <SuppliersList
            data={suppliers}
            itemAction={itemAction}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Index)
